export enum RegionsCodes {
  Europe = 'eu1',
  China = 'cn1',
}
